import React from 'react'
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


const BasicDashboard = () => {
  return (
    <Box>
        <Typography>Dashboard</Typography>
    </Box>
  )
}

export default BasicDashboard